export default __webpack_public_path__ + "static/media/extension-02.1d5f445e.png";